export const environment = {
  production: false,
  // Serve /get-pet-insurance from src/app/mock/getAllMock.dev.ts instead of the backend.
  mockPetInsurance: false,
  apiBaseUrl: 'https://cp-api-dev.calingo.ch',
  // Cognito hosted-UI domain. Replaces oauth.domain from aws-exports, which `amplify env checkout`
  // regenerates with the pool's amazoncognito.com prefix domain. Empty keeps that prefix domain.
  authDomain: 'cp-auth-dev.calingo.ch',
  petApiUrl: 'https://v9j8xzj28b.execute-api.eu-central-1.amazonaws.com',
  petClosingUrl: 'https://d23s3uwujxq6ap.cloudfront.net/'
};
